import * as React from 'react';
import { useState, useEffect } from 'react';
import { TableBody, TableRow, TableCell, Box, Chip, TablePagination } from '@mui/material';

import { readStringDate, monthsArray } from '../../../function utils/functionUtils';

import useTable from '../../../component/UseTable/UseTable_v1';
import { FilterDataSelector } from 'store1/client data/client.data.slice.selector';
import { startFilterInvoicesListData } from '../../../store1/invoice data/invoiceData.slice.selector';
import BackdropComp from '../../../component/MuiReusableComponents/backdrop/backdrop';
import { useSelector, useDispatch } from 'react-redux';

import { setPage, setRowsPerPage, pageIndexSelector, pageSizeSelector } from '../../../store1/invoice data/invoiceData.slice.selector';
const InvoiceTable = (props) => {
    const {
        data,
        headCells = [],
        dispatchAPI,
        rowsCount,
        isLoading,
        loadingMessage,
        pageSize,
        pageIndex,
        setPageSize,
        setPageIndex,
        pathName,
        ActionComponent
    } = props;

    const dispatch = useDispatch();
    const page = useSelector(pageIndexSelector);
    const rowsPerPage = useSelector(pageSizeSelector);
    const [prevPath, setPrevPath] = useState('');
    const [userData, setUserData] = useState([]);
    const filterData = useSelector(FilterDataSelector);
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        }
    });
    const fetchData = () => {
        dispatch(
            startFilterInvoicesListData({
                clientName: filterData.clientName || 0,
                invoiceStatus: 1,
                invoiceNumber: filterData.invoiceNumber || '',
                startDateValue: filterData.startDateValue || '',
                endDateValue: filterData.endDateValue || '',
                pageIndex: page,
                pageSize: rowsPerPage
            })
        );
    };

    const handleChangePage = (event, newPage) => {
        dispatch(setPage(newPage + 1));
    };

    const handleChangeRowsPerPage = (event) => {
        dispatch(setRowsPerPage(parseInt(event.target.value)));
        dispatch(setPage(1));
    };

    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage]);

    useEffect(() => {
        setUserData(data);
        if (prevPath !== pathName) {
            dispatch(setPage(1));
            dispatch(setRowsPerPage(10));
        }
        setPrevPath(pathName);
    }, [data, pathName]);

    const { TblContainer, TblHeader, TblPagination, tblDataAfterPaginationAndSorting, emptyRows } = useTable(
        userData,
        headCells,
        filterFn,
        fetchData,
        rowsCount,
        pageSize,
        pageIndex
    );

    return (
        <>
            <>
                <Box>
                    <BackdropComp message={loadingMessage} isLoading={isLoading} />
                </Box>
                <TblContainer>
                    <TblHeader />
                    <TableBody>
                        {userData?.map((row, idx) => (
                            <TableRow key={row.id} size="small">
                                {headCells.map((head, idxHead) => {
                                    if (head.id === 'id' && head.label === 'S No.') {
                                        const serialNumber = page * rowsPerPage + idx + 1 - rowsPerPage;
                                        return <TableCell key={`${idx}${idxHead}`}>{serialNumber}</TableCell>;
                                    } else if (head.id === 'added_date') {
                                        const dateValue = row[head.id];
                                        return (
                                            <TableCell align="center" key={`${idx}${idxHead}`}>
                                                {dateValue && dateValue.trim() !== '' ? (
                                                    readStringDate(dateValue)
                                                ) : (
                                                    <span style={{ fontStyle: 'italic', color: '#888' }}>Not Finalised</span>
                                                )}
                                            </TableCell>
                                        );
                                    } else if (head.id === 'invoice_number') {
                                        const invoiceNumber = row[head.id];
                                        return (
                                            <TableCell align="center" key={`${idx}${idxHead}`}>
                                                {invoiceNumber && invoiceNumber.trim() !== '' ? (
                                                    invoiceNumber
                                                ) : (
                                                    <span style={{ fontStyle: 'italic', color: '#888' }}>Not Finalised</span>
                                                )}
                                            </TableCell>
                                        );
                                    } else if (
                                        head.id === 'added_date_time' ||
                                        head.id === 'expense_date' ||
                                        head.id === 'approval_date' ||
                                        head.id === 'run_date'
                                    ) {
                                        return <TableCell align="center">{readStringDate(row[head.id])}</TableCell>;
                                    }

                                    if (head.id === 'exchange_rate') {
                                        return (
                                            <TableCell align="right" size="small" key={`${idx}${idxHead}`}>
                                                {row[head.id] === 1 ? 'N/A' : row[head.id].toFixed(2)}
                                            </TableCell>
                                        );
                                    }

                                    if (head.id === 'total_amount') {
                                        const totalAmount = parseFloat(row.total_amount);
                                        const exchangeRate = parseFloat(row.exchange_rate);

                                        const convertedAmount = exchangeRate && !isNaN(exchangeRate) ? totalAmount / exchangeRate : 0;

                                        const formattedAmount = Number.isNaN(convertedAmount)
                                            ? '0.00'
                                            : row.currency_type === 'INR'
                                            ? convertedAmount
                                            : convertedAmount.toFixed(2);

                                        return (
                                            <TableCell align="right" size="small" key={`${idx}${idxHead}`}>
                                                {formattedAmount}
                                            </TableCell>
                                        );
                                    }

                                    if (head.id === 'action') {
                                        return (
                                            <TableCell size="small" key={`${idx}${idxHead}`} sx={{ width: '80px' }}>
                                                <ActionComponent row={row} pageSize={pageSize} pageIndex={pageIndex} />
                                            </TableCell>
                                        );
                                    }

                                    if (head.id === 'status') {
                                        return (
                                            <TableCell size="small" key={`${idx}${idxHead}`}>
                                                {Boolean(row[head.id]) ? (
                                                    <Chip color="success" variant="outlined" label={'Active'} align="center" />
                                                ) : (
                                                    <Chip color="error" variant="outlined" label={'In-active'} align="center" />
                                                )}
                                            </TableCell>
                                        );
                                    }
                                    if (head.id === 'month') {
                                        return (
                                            <TableCell size="small" align="left">
                                                {monthsArray[row[head.id] - 1]}
                                            </TableCell>
                                        );
                                    }

                                    return (
                                        <TableCell key={`${idx}${idxHead}`} size="small">
                                            {row[head.id]}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                        {emptyRows > 0 && (
                            <TableRow
                                style={{
                                    height: 53 * emptyRows
                                }}
                            >
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}
                    </TableBody>
                </TblContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 35, 45]}
                    component="div"
                    count={rowsCount}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </>
        </>
    );
};
export default InvoiceTable;
